import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-loop-right', 'ArrowLoopRight', [["path",{"d":"M12 21v-13a4 4 0 1 0 -4 4h13"}],["path",{"d":"M17 16l4 -4l-4 -4"}]]);